










import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import LoginForm from '../components/LoginForm.vue'
import { getModule } from 'vuex-module-decorators'
import { AuthModule } from '@/store/modules'

interface ILoginFormData {
  email: string,
  password: string,
  type: 'user' | 'employer'
}

@Component({
  components: {
    LoginForm
  }
})
export default class Login extends Vue {
  errorMessage: string | null = null;
  authStore = getModule(AuthModule)

  loading = false

  async mounted() {
    await this.authStore.refreshAuth()
    if (this.authStore.user) {
      this.$router.push('/')
    }
  }

  /** Make a login request to the backend */
  async login(data: ILoginFormData) {
    this.loading = true
    try {
      if (data.type === 'user') {
        const result = await this.authStore.loginUser({ email: data.email, password: data.password })
        setTimeout(() => {
          this.loading = false
          this.directUser()
        }, 500)
        
      } else {
        const result = await this.authStore.loginEmployer({ email: data.email, password: data.password })
        setTimeout(() => {
          this.loading = false
          this.directUser()
        }, 500)
      }
    } catch (err) {
      this.loading = false
      // if (err.message && err.message.length) {
      //   this.errorMessage = err.message
      // } else {
        this.errorMessage = 'Login failed. Please try again.'
      // }
    }
  }

  /** Upon a successful login, move the user to the next page */
  directUser() {
    if (this.$route.query['redirect'] && typeof this.$route.query['redirect'] === 'string') {
      const query = { ...this.$route.query }
      delete query.redirect
      this.$router.push({ path: this.$route.query['redirect'], query })
    } else {
      this.$router.push('/')
    }
  }
}
